"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const Radio_1 = __importDefault(require("@Components/Radio"));
const Button_1 = require("@Components/Buttons/Button");
const mobx_react_1 = require("mobx-react");
const contexts_1 = require("@App/contexts");
const works_report_request_1 = require("@Entities/report/works-report-request");
const search_1 = require("@App/api/routes/search");
const export_type_1 = require("@App/enum/export-type");
const ExportOverclaimsForm = (props) => {
    const { exportStore, overclaimSearchStore, preloaderStore, rightsholderStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    (0, react_1.useEffect)(() => {
        // fyi this store call opens the preloader, if more api calls are added then the preloader will need be dealt with
        exportStore.setExportType(export_type_1.ExportType.OVERCLAIMS);
        exportStore.loadExportFormats().then();
    }, []);
    const overclaimExportFormats = exportStore.exportFormats;
    const [overclaimsReportRequest, setOverclaimsReportRequest] = (0, react_1.useState)(works_report_request_1.WorksReportRequestDTO.fromWorkQuery(overclaimSearchStore.overclaimSearchQuery || {}));
    const onFormatChange = (value) => {
        setOverclaimsReportRequest(Object.assign(Object.assign({}, overclaimsReportRequest), { format: value.value }));
    };
    const isFormValid = () => !!(overclaimsReportRequest === null || overclaimsReportRequest === void 0 ? void 0 : overclaimsReportRequest.format);
    const onSubmitOverclaimsExportRequest = () => {
        if (isFormValid()) {
            preloaderStore.openTransparentPreloader(true);
            const rightsholderId = rightsholderStore.currentRightsholderId;
            (0, search_1.submitReportRequest)(rightsholderId, overclaimsReportRequest, export_type_1.ExportType.OVERCLAIMS)
                .then(() => {
                props.setIsFormSubmitted(true);
            })
                .finally(() => preloaderStore.openTransparentPreloader(false));
        }
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Radio_1.default, { options: overclaimExportFormats, field: { name: 'File Type' }, direction: "column", onChange: onFormatChange, title: 'File Type:' }),
        react_1.default.createElement("div", { className: 'download-button' },
            react_1.default.createElement(Button_1.Button, { mainColor: true, type: 'primary', disabled: !isFormValid(), onClick: () => onSubmitOverclaimsExportRequest() }, "Download"))));
};
exports.default = (0, mobx_react_1.observer)(ExportOverclaimsForm);
